/**
 * 控制页面滚动
 * 避免修改top定位造成地址栏弹出
 */
export const lockBodyScroll = (() => {
  let init = false;
  let originalOverflow = '';

  return function (lock: boolean, touchAction = false) {
    if (lock) {
      if (!init) {
        // 保存body原始的overflow属性
        originalOverflow = document.body.style.overflow;
        init = true;
      }
      // 不允许滚动
      document.body.style.overflow = 'hidden';
      // 在iphone中的safari中由于向下滚动出现地址栏，页面高度变化，导致body overflow:hidden失效；
      // 所以增加一个workaround是给body添加touchAction = none，禁止滚动
      if (touchAction) {
        document.body.style.touchAction = 'none';
      }
    } else {
      if (document.body.style.overflow !== 'hidden') return;
      // 解锁滚动
      document.body.style.overflow = originalOverflow;
      if (touchAction) {
        document.body.style.touchAction = 'unset';
      }
    }
  };
})();

/** 清除不需要的Scripts */
export function removeDoms(selector: string) {
  const doms = document.querySelectorAll(selector);

  // 遍历找到的 script 元素并移除它们
  doms.forEach((dom) => {
    if (dom.parentNode) {
      dom.parentNode.removeChild(dom);
    }
  });
}

/**
 *
 * @description 按钮根据视频进度做渐变动画切换, 放在useEffect中
 * @param {Element} tagEle
 * @param {Element} videoEle
 * @param {[{visibleTime?:number,startTime: number, endTime: number}]} animationList 默认visibleTime是0
 * @param {number} btnHideTime 按钮在开始阶段隐藏的时间
 * @return {function} removeListener
 */
export function tagSwitchAnimation(
  tagEle: HTMLElement,
  videoEle: HTMLVideoElement,
  animationList: { visibleTime?: number; startTime: number; endTime: number }[],
  btnHideTime: number = 0
) {
  if (!tagEle || !videoEle) return;
  const step = () => {
    let ratio = 0;
    // 隐藏按钮
    if (videoEle.currentTime < btnHideTime) {
      tagEle.style.opacity = '0';
      requestAnimationFrame(step);
      return;
    }
    tagEle.style.opacity = '1';

    for (let i = 0; i < animationList.length; i++) {
      // 找到当前正在执行的按钮配置
      const animation = animationList[i];
      const nextAnimation = animationList[i + 1];
      const nextAnimationVisibleTime = nextAnimation?.visibleTime ?? videoEle.duration;
      //  处理当前正在执行的按钮动画：visibleTime和下一个按钮的visibleTime之间
      if (videoEle.currentTime >= (animation?.visibleTime ?? 0) && videoEle.currentTime < nextAnimationVisibleTime) {
        // 开始滑动
        const total = animation.endTime - animation.startTime;
        if (videoEle.currentTime < animation.startTime) {
          ratio = 0;
          break;
        } else if (videoEle.currentTime < animation.endTime) {
          ratio = ((videoEle.currentTime - animation.startTime) / total) * 100;
          break;
        } else if (videoEle.currentTime < animation.endTime + 0.1) {
          ratio = 100;
          break;
        } else if (videoEle.currentTime < nextAnimationVisibleTime) {
          ratio = 100;
        }
      }
    }

    if (tagEle.children[0] instanceof HTMLElement && tagEle.children[1] instanceof HTMLElement) {
      tagEle.children[0].style.clipPath = `inset(0 0 0 ${ratio}%)`;
      tagEle.children[1].style.clipPath = `inset(0 ${100 - ratio}% 0 0)`;
    }
    requestAnimationFrame(step);
  };

  let requestAnimationFrameId = 0;

  const playListener = () => {
    requestAnimationFrameId = requestAnimationFrame(step);
  };

  const pauseListener = () => cancelAnimationFrame(requestAnimationFrameId);

  videoEle.addEventListener('play', playListener);
  videoEle.addEventListener('pause', pauseListener);

  // 清除监听
  const removeListener = () => {
    videoEle.removeEventListener('play', playListener);
    videoEle.removeEventListener('pause', pauseListener);
  };

  return removeListener;
}

/**
 *
 * @description 判断元素类型video|img|null
 * @param {HTMLElement} element
 * @returns {'video'|'img'|null}
 */
export const isVideoOrImg = (element: HTMLElement) => {
  if (element instanceof HTMLVideoElement) {
    return 'video';
  } else if (element instanceof HTMLImageElement) {
    return 'img';
  }
  return null;
};
